enum ComponentIds {
  FORM_AUTOSUGGESTINPUT = 'Form.AutoSuggestInput',

  COMPONENT_HEADING = 'Component.Heading',
  COMPONENT_IMAGE = 'Component.Image',
  COMPONENT_FILE_INPUT = 'Component.FileInput',
}

export default ComponentIds
